import Clear from "@/layouts/Clear.vue";

export default {
  path: "/cancellation-requests",
  component: Clear,
  children: [
    {
      path: "",
      name: "cancellation-requests.index",
      component: () =>
        import("@/views/CancellationRequests/CancellationRequestsList.vue"),
    },
  ],
};
